import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Zoom from "@mui/material/Zoom";
import Divider from "@mui/material/Divider";

import Mcgie from "./posgrado/studyRoadmaps/Mcgie";
import Dle from "./posgrado/studyRoadmaps/Dle";

import dgiAfiche from "../images/dgi/2.png";
import dleAfiche from "../images/dle/3.png";
import mcgieAfiche from "../images/mcgie/6.png";
import dbiAfiche from "../images/dbi/dbiAfiche1.jpeg";

import SchoolIcon from "@mui/icons-material/School";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import DateRangeIcon from "@mui/icons-material/DateRange";
import SavingsIcon from "@mui/icons-material/Savings";
import AddCardIcon from "@mui/icons-material/AddCard";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LaptopChromebookIcon from "@mui/icons-material/LaptopChromebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FeedIcon from "@mui/icons-material/Feed";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Dgi from "./posgrado/studyRoadmaps/Dgi";
import Dbi from "./posgrado/studyRoadmaps/Dbi";

function PaginaPosgrado({ type }) {
  const programas = {
    dgi: {
      titulo:
        "DIPLOMADO EN GESTIÓN INTEGRADA, CALIDAD, MEDIO AMBIENTE, SEGURIDAD Y SALUD OCUPACIONAL",
      inicio: "Mayo 2026",
      version: "Décimo Octava versión",
      objetivo: "",
      duracion: "6 Meses",
      colegiatura: "Bs. 6,000",
      matricula: "Bs. 560",
      modalidad: "Virtual",
      horarios: "Lunes a Viernes de 19:00 a 21:30",
      titulos: [
        "Diploma en Gestión Integrada, Calidad, Medio Ambiente, Seguridad y Salud Ocupacional",
        "Respaldo para la obtención de Carnet de Inspetor SySO",
        "Respaldo para el registro en el RENCA",
      ],
      modalidadPago:
        "Pago en 6 cuotas de Bs. 1,000 y descuento del 5% por pago al contado.",
      enlaceInscripcion: "https://forms.gle/DXqTewqXTFoyCNcm6",
      mensajeWsp:
        "Diplomado%20en%20Gesti%C3%B3n%20Integrada,%20Calidad,%20Medio%20Ambiente,%20Seguridad%20y%20Salud%20Ocupacional",
      afiche: dgiAfiche,
    },
    dle: {
      titulo:
        "DIPLOMADO EN LOGÍSTICA EMPRESARIAL Y GESTIÓN DE LA CADENA DE SUMINISTROS",
      inicio: "Abril 2026",
      version: "Undécima versión",
      objetivo:
        "El objetivo del Diplomado es de dotar a los profesionales con los elementos básicos de la logística moderna y la gestión de las cadenas de suministro, de forma tal que les posibilite actuar eficientemente en las tareas relacionadas con el análisis y gestión de los sistemas logísticos como centro de la gestión de las cadenas de suministro.",
      duracion: "6 Meses",
      colegiatura: "Bs. 6,000",
      matricula: "Bs. 560",
      modalidad: "Virtual",
      horarios: "Lunes a Viernes de 19:00 a 21:30",
      titulos: [
        "Diploma en Logística Empresarial y Gestión de la Cadena de Suministros",
      ],
      enlaceInscripcion: "https://forms.gle/3TN2Y7PwJiGLxsFu5",
      modalidadPago:
        "Pago en 6 cuotas de Bs. 1,000 y descuento del 5% por pago al contado.",
      mensajeWsp:
        " Diplomado%20en%20Log%C3%ADstica%20Empresarial%20y%20Gesti%C3%B3n%20de%20la%20Cadena%20de%20Suministros",
      afiche: dleAfiche,
    },
    mcgie: {
      titulo: "MAESTRÍA EN CIENCIAS DE GESTIÓN INDUSTRIAL Y EMPRESARIAL",
      inicio: "Agosto 2026",
      version: "Duodécima versión",
      objetivo:
        "El objetivo de la Maestría es de ampliar y profundizar los conocimientos de los profesionales formando recursos humanos capaces de impartir ciencia y de crear innovación tecnológica mediante la investigación.",
      duracion: "20 Meses",
      colegiatura: "Bs. 35,000",
      matricula: "2 Matrículas de Bs. 1,679",
      modalidad: "Híbrida",
      horarios: "Lunes a Viernes de 19:00 a 21:30",
      titulos: [
        "Magister Scientiarum en Gestión Industrial y Empresarial",
        "Diploma en Gerencia y Recursos Humanos",
        "Diploma en Gestión de Producción",
      ],
      modalidadPago:
        "Pago en 17 cuotas de Bs. 2,000 y 1 cuota de Bs. 1,000, con descuento del 5% por pago al contado.",
      enlaceInscripcion: "https://forms.gle/igToVe7CdxpGsoTT8",
      mensajeWsp:
        "Maestría%20en%20Ciencias%20de%20Gestión%20Industrial%20y%20Empresarial",
      afiche: mcgieAfiche,
    },
    dbi: {
      titulo:
        "DIPLOMADO EN BIOTECNOLOGÍA INDUSTRIAL Y APLICACIONES ESTRATÉGICAS",
      inicio: "Abril 2026",
      version: "Primera versión",
      objetivo:
        "El Diplomado en Biotecnología Industrial y Aplicaciones Estratégicas tiene como objetivo formar profesionales altamente capacitados en el área de biotecnología industrial, con énfasis en la aplicación estratégica de procesos biotecnológicos para el desarrollo sostenible y la innovación tecnológica.",
      duracion: "6 Meses",
      colegiatura: "Bs. 5,000",
      matricula: "Bs. 560",
      modalidad: "Virtual",
      horarios: "Lunes a Viernes de 19:00 a 21:30",
      titulos: [
        "Diploma en Biotecnología Industrial y Aplicaciones Estratégicas",
      ],
      enlaceInscripcion: "https://forms.gle/gTagMjNnRsKbC7bz8",
      modalidadPago:
        "Pago en 4 cuotas de Bs.850 y 2 cuotas de Bs.800 descuento del 5% por pago al contado.",
      mensajeWsp:
        "Diplomado%20en%20Biotecnología%20Industrial%20y%20Aplicaciones%20Estratégicas",
      afiche: dbiAfiche,
    },
  };
  return (
    <Zoom in={true} timeout={1000} unmountOnExit>
      <Container
        sx={{
          backgroundColor: "white",
          borderRadius: 5,
          marginX: "auto",
          marginY: "10vh",
          paddingTop: "2rem",
          paddingBottom: "2rem",
          overflow: "auto",
          height: "80vh",
          width: "100%",
        }}
      >
        <Grid sx={{ padding: 2 }} width={"100%"} container spacing={2}>
          <Grid
            size={{ xs: 12, md: 5 }}
            item
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              style={{
                borderRadius: 8,
                boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
              }}
              width={"100%"}
              src={programas[type].afiche}
              alt={programas[type].titulo}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 7 }} item>
            <Stack spacing={2}>
              <Typography textAlign="center" variant="h4">
                <strong>{programas[type].titulo}</strong>
              </Typography>
              <Typography textAlign="center" variant="h5">
                <strong>{programas[type].version}</strong>
              </Typography>
              <Typography textAlign="justify" variant="body1">
                {programas[type].objetivo}
              </Typography>
              <Typography textAlign="center" variant="h5">
                <strong>Títulos otorgados</strong>
              </Typography>
              <Grid container justifyContent="center" spacing={2}>
                <List>
                  {programas[type].titulos.map((item, index) => (
                    <ListItem>
                      <ListItemIcon>
                        <SchoolIcon />
                      </ListItemIcon>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
              </Grid>
              <Divider />
              <Typography textAlign="center" variant="h5">
                <strong>Información General</strong>
              </Typography>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item size={6}>
                  <List width={"100%"}>
                    <ListItem>
                      <ListItemIcon>
                        <CalendarMonthIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={`INICIO DE ACTIVIDADES`}
                        secondary={programas[type].inicio}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <TimelapseIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={`DURACIÓN`}
                        secondary={programas[type].duracion}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <DateRangeIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={`HORARIOS`}
                        secondary={programas[type].horarios}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item size={6}>
                  <List width={"100%"}>
                    <ListItem>
                      <ListItemIcon>
                        <SavingsIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={`COLEGIATURA`}
                        secondary={programas[type].colegiatura}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <AddCardIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={`MATRÍCULA`}
                        secondary={programas[type].matricula}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <LaptopChromebookIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={`MODALIDAD`}
                        secondary={programas[type].modalidad}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid container item size={12} justifyContent={"center"}>
                  <List width={"100%"}>
                    <ListItem>
                      <ListItemIcon>
                        <AttachMoneyIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={`Modalidades de pago disponibles`}
                        secondary={programas[type].modalidadPago}
                      />
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Stack>
          </Grid>
          <Grid item size={12}>
            <Divider sx={{ marginY: 2 }} variant="middle"></Divider>
          </Grid>
            <Grid item size={12} textAlign="center">
              <Typography textAlign="center" variant="h5">
                <strong>Más información</strong>
              </Typography>
            </Grid>
            <Grid item size={12}>
              <Divider></Divider>
            </Grid>
            <Grid item size={6} textAlign="center">
              <a
                href={
                  "https://wa.me/59164256418?text=Hola%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20" +
                  programas[type].mensajeWsp
                }
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contactar por WhatsApp"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  backgroundColor: "#25D366",
                  color: "#ffffff",
                  padding: "10px 16px",
                  borderRadius: 8,
                  textDecoration: "none",
                  fontWeight: 700,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                }}
              >
                <WhatsAppIcon style={{ marginRight: 8 }} />
                Contactar por WhatsApp
              </a>
            </Grid>
            <Grid item size={6} textAlign="center">
              <a
                href={programas[type].enlaceInscripcion}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Acceder al formulario de pre-inscripción"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  backgroundColor: "#1976d2",
                  color: "#ffffff",
                  padding: "10px 16px",
                  borderRadius: 8,
                  textDecoration: "none",
                  fontWeight: 700,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                }}
              >
                <FeedIcon style={{ marginRight: 8 }} />
                Formulario de Pre-inscripción
              </a>
            </Grid>
          <Grid item size={12} sx={{ marginTop: 2 }}>
            <Divider></Divider>
          </Grid>
          <Grid
            item
            size={{ xs: 12 }}
            alignContent="center"
            sx={{ paddingX: "5dvw" }}
          >
            <Typography textAlign="center" variant="h5">
              <strong>Plan de estudios</strong>
            </Typography>
            {type === "mcgie" ? (
              <>
                <Mcgie />
              </>
            ) : type === "dgi" ? (
              <>
                <Dgi />
              </>
            ) : type === "dle" ? (
              <>
                <Dle />
              </>
            ) : type === "dbi" ? (
              <>
                <Dbi />
              </>
            ) : (
              <></>
            )}
          </Grid>
          <Grid item size={{ xs: 12 }}>
            <Grid item size={12} sx={{ marginTop: 2 }}>
              <Accordion
                disabled
                variant="elevation"
                elevation={3}
                sx={{ borderRadius: 2 }}
              >
                <AccordionSummary
                  sx={{ bgcolor: "green", color: "white", borderRadius: 1 }}
                  expandIcon={
                    <ExpandMoreIcon fontSize="large" color="action" />
                  }
                >
                  <Typography variant="h6">
                    Para recibir más información y resolver dudas sobre el
                    proceso de inscripción, haga clic aquí
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <iframe
                    title="Formulario de pre-inscripción"
                    width="100%"
                    height="550px"
                    src="https://forms.office.com/Pages/ResponsePage.aspx?id=1aZ8nG0NoE6TrPoXLVTE4BQWjVIl2OJHkgF1tkP8wh9UNUQyWElPNTlZMTFUUTJIMjA1OFVSUE1BRS4u&embed=true"
                    frameborder="0"
                    marginwidth="0"
                    marginheight="0"
                    style={{
                      border: "none",
                      maxWidth: "100%",
                      maxHeight: "100%",
                      borderRadius: 8,
                    }}
                    allowfullscreen
                    webkitallowfullscreen
                    mozallowfullscreen
                    msallowfullscreen
                  >
                    {" "}
                  </iframe>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Zoom>
  );
}

export default PaginaPosgrado;
